/**
 * @deprecated Use src/constants/plans.ts instead
 * This file is kept for backward compatibility only
 */

// Re-export from new centralized location
export { 
  PLAN_PRICING as ASAAS_PLAN_PRICES,
  PLAN_COMMERCIAL_NAMES as ASAAS_PLAN_NAMES,
  centsToReais,
  reaisToCents
} from './plans';

// Re-export types from types/plans
export type { PlanType as AsaasPlanId, BillingPeriod as AsaasBillingPeriod } from '@/types/plans';

// Asaas API endpoints (kept for backward compatibility)
export const ASAAS_API_BASE_URL = 'https://www.asaas.com/api/v3';

// Billing cycle mapping to Asaas
export const ASAAS_BILLING_CYCLES = {
  'weekly': 'WEEKLY',
  'monthly': 'MONTHLY', 
  'quarterly': 'QUARTERLY'
} as const;

// Feature flag for Asaas migration
export const ENABLE_ASAAS = true; // Set to true to enable Asaas, false to use Stripe
